import { Tables } from '@/types/database.types';
import { useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import { create } from 'zustand';
import { persist, createJSONStorage, PersistOptions } from 'zustand/middleware';

export const STORAGE_WORKSPACE_ID_KEY = 'workspace_id';

type State = {
  workspaceId: string;
  workspace: Tables<'workspace'>;
};

type Action = {
  setWorkspace: (workspace: State['workspace']) => void;
};

type WorkspaceStore = State & Action;

type WorkspacePersist = {
  workspaceId: string;
};

const persistOptions: PersistOptions<WorkspaceStore, WorkspacePersist> = {
  name: 'workspace-storage',
  partialize: (state) => ({ workspaceId: state.workspaceId }),
};

export const useWorkspaceStore = create<WorkspaceStore>()(
  persist(
    (set) => ({
      workspaceId: '',
      workspace: {} as Tables<'workspace'>,
      setWorkspace: (workspace) =>
        set(() => ({
          workspaceId: workspace.workspace_id!,
          workspace: workspace,
        })),
    }),
    persistOptions
  )
);
